export const HC_HOME_VISIBLE_TRANSACTION_COUNT = 3
export const HC_SEARCH_SESSION_ID_COOKIE_KEY = 'help_center_search_session_id'
export const HC_ROOT_FAQ_ID = 3
export const HELP_CENTER_SESSION_ID = 'help_center_session_id'
